module.exports = __webpack_public_path__ + "static/klimaatverandering-wateroverlast-zeespiegelstijging-mobile-1b1f0d8ea7400be7ad36f07b238250f3.jpg";